import { wrap } from 'src/packages/mobx-di/wrap';

import type { PluginInstanceController, PluginObject, PluginName } from 'src/features/plugins-service/types';

import styles from '../directory-page-header.module.scss';

type Props = {
  plugins: PluginObject<PluginName, PluginInstanceController[PluginName]>[];
};

export const PluginsElements = wrap<Props>(function PluginsElements({ plugins }) {
  if (!plugins.length) {
    return null;
  }

  return (
    <div className={styles.pluginsElementsWrapper}>
      {plugins.map((plugin) => {
        return <div key={plugin.pluginController.name}>{plugin.renderer(plugin.pluginController)}</div>;
      })}
    </div>
  );
});
